// extracted by mini-css-extract-plugin
export default {"promo-box":"_1qddir3","promoBox":"_1qddir3","promo-with-badge":"_o93x88","promoWithBadge":"_o93x88"};